import { GlobalStyles } from '@experiences/theme';
import { UiText } from '@experiences/ui-common';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import React from 'react';
import { useIntl } from 'react-intl';

import useEcommerceLearnMoreViewModel from './EcommerceLearnMoreViewModel';
import ProductDescriptionList from './ProductDescriptionList';

const useStyles = makeStyles(theme => ({
    ...GlobalStyles(theme),
    ...createStyles({
        headerContainer: {
            flexDirection: 'column',
            display: 'flex',
            alignItems: 'left',
        },
        productSubtitle: {
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '16px',
            color: theme.palette.semantic.colorForeground,
            whiteSpace: 'pre-wrap',
        },
    }),
}));

const EcommerceLearnMoreComponent: React.FC<{
    productCode: string;
    planType: string;
}> = ({
    productCode, planType,
}) => {
    const classes = useStyles();
    const { formatMessage: translate } = useIntl();
    const { getLearnMoreSubtitleTranslationId } = useEcommerceLearnMoreViewModel();

    return (
        <div className={classes.headerContainer}>
            <UiText
                className={classes.productSubtitle}
                data-cy={`ecommerce-learn-more-subtitle-${productCode}`}>
                {translate({ id: getLearnMoreSubtitleTranslationId(productCode, planType) })}
            </UiText>
            <ProductDescriptionList
                productCode={productCode}
                planType={planType} />
            {/** TODO - Decoment this as part of [PLT-33277]
            <IncludedServicesList productCode={productCode} />
            */}

        </div>);
};

export default EcommerceLearnMoreComponent;
